import React from 'react'
import PropTypes from 'prop-types'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import AusbildungFortschritt from '#components/a/AusbildungFortschritt'
import Ausbildungsnachweise from '#components/o/MeineAusbildung/Ausbildungsnachweise'
import Praxisaufgaben from '#components/o/MeineAusbildung/Praxisaufgaben'
import VersetzungsplanDashboard from '#components/o/MeineAusbildung/VersetzungsplanDashboard'
import useAzubiDashboardData from '#hooks/store/useAzubiDashboardData'
import useCurrentUser from '#hooks/store/useCurrentUser'
import useUserModuleSettings from '#hooks/useUserModuleSettings'
import Ausbildungsplan from '#components/o/MeineAusbildung/Ausbildungsplan'
import WissensportalDashboard from '#components/o/MeineAusbildung/WissensportalDashboard'
import Greeting from '#components/a/Greeting'
import Loading from '#components/a/Loading'
import BerufwechselNote from '#components/o/MeineAusbildung/BerufwechselNote'
import AufbauAusbildungsNote from '#components/o/MeineAusbildung/AufbauAusbildungsNote'
import {parseISO} from 'ag-common/facades'
import youngTalentAwardIcon from '../../assets/images/youngTalentAwardIcon.jpg'
export function MeineAusbildung(props) {
  const {firstname, ausbildungsstart, ausbildungsende, id} = props.userInfo

  const {
    newAusbildungsberuf,
    newAufbauAusbildungsberuf,
    ausbildungsBerufString,
    newAusbildungsberufString,
    newAufbauAusbildungsberufString,
  } = useCurrentUser()

  const {
    nachweise,
    praxisaufgaben,
    wissensportal,
    ausbildungsplan,
    isLoading,
    versetzungsplaene,
    isLoadingVersetzungsplaene,
  } = useAzubiDashboardData()
  const {showModule} = useUserModuleSettings()

  const moduleDashboard = {
    ausbildungsplan: <Ausbildungsplan userId={id} {...ausbildungsplan} />,
    nachweise: <Ausbildungsnachweise {...nachweise} />,
    praxisaufgabenOverview: <Praxisaufgaben {...praxisaufgaben} />,
    wissensportal: <WissensportalDashboard wissensportalCompletion={wissensportal} />,
  }

  const listOfShownModules = filterModules(moduleDashboard, showModule)

  const isLoadingData = isLoadingVersetzungsplaene || isLoading
  function renderHeader() {
    return (
      <div className="header-wrapper">
        <Greeting firstName={firstname} />
        {!isLoading && ausbildungsstart && ausbildungsende && (
          <AusbildungFortschritt start={parseISO(ausbildungsstart)} end={parseISO(ausbildungsende)} />
        )}
      </div>
    )
  }

  function renderBody() {
    return (
      <div>
        <div className="break" />
        <div className="box-container">
          {newAusbildungsberuf && (
            <BerufwechselNote oldBerufTitle={ausbildungsBerufString} newBerufTitle={newAusbildungsberufString} />
          )}
          {newAufbauAusbildungsberuf && (
            <AufbauAusbildungsNote aufbauAusbildungsBeruf={newAufbauAusbildungsberufString} />
          )}

          {/* Hardcoded infobox for young talent award EDK-3035 */}
          {/* <div className="progressoverview" data-testid="infoboxdashboard">
            <div data-testid="infoboxdashboard" className="infoboxdashboard">
              <img src={youngTalentAwardIcon} alt="EDEKA Young Talent Award" height={72} />
              <div className="infoboxdashboard__text">
                Vom 02.02. bis 11.03.2026 findet der EDEKA Young Talent Award statt. In drei Runden kannst du dein
                Können zeigen. Sei dabei und mach mit auf{' '}
                <a href="https://www.young-talent-award.edeka" target="_blank">
                  young-talent-award.edeka
                </a>
              </div>
            </div>
          </div> */}
          {/* Hardcoded infobox for young talent award EDK-3035 */}

          {showModule('versetzungsplan') && <VersetzungsplanDashboard versetzungsplaene={versetzungsplaene[0]} />}
          <div className="break" />
          <div className="col-flex">
            {listOfShownModules[0]}
            {listOfShownModules.length > 2 && listOfShownModules[2]}
          </div>
          <div className="col-flex">
            {listOfShownModules[1]}
            {listOfShownModules.length > 3 && listOfShownModules[3]}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="meineAusbildung">
      {renderHeader()}
      {isLoadingData ? <Loading /> : renderBody()}
    </div>
  )
}

MeineAusbildung.propTypes = {
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
    ausbildungsstart: PropTypes.string,
    ausbildungsende: PropTypes.string,
    ausbildungsberuf: PropTypes.number,
    newAusbildungsberuf: PropTypes.number,
    id: PropTypes.number,
  }).isRequired,
}

function filterModules(moduleDashboard, showModule) {
  return Object.keys(moduleDashboard)
    .filter(key => showModule(key))
    .reduce((res, key) => {
      res.push(moduleDashboard[key])
      return res
    }, [])
}

export default UserInfoHOC(MeineAusbildung)
